import { AuthApi } from "../../Api";

import {
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE
} from "../../Constants";

function requestUserInfo() {
  return {
    type: GET_USER_REQUEST,
    isFetching: true
  };
}

function userInfoSuccess(user) {
  return {
    type: GET_USER_SUCCESS,
    isFetching: false,
    user
  };
}

function userInfoError(errorMessage) {
  return {
    type: GET_USER_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const getUserInfo = payload => (dispatch, getState) => {
  dispatch(requestUserInfo());
  AuthApi.getUserInfo(getState().auth)
    .then(res => {
      dispatch(userInfoSuccess(res));
      if (payload && payload.onSuccess)
        payload.onSuccess(res.defaultProfile.defaultLanguage);
    })
    .catch(err => dispatch(userInfoError(err)));
};
